export default __webpack_public_path__ + "static/media/warning--road-bump--g2.82cf40b3.png";